(function () {
  class LocalizationForm extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-localization-select]');
      if (!select) return;

      select.addEventListener('change', () => {
        if (select.form) select.form.submit();
      });
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;

      const loadRecommendations = () => {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(() => {});
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, currentObserver) => {
          if (!entries[0].isIntersecting) return;
          currentObserver.unobserve(this);
          loadRecommendations();
        }, { rootMargin: '0px 0px 280px 0px' });
        observer.observe(this);
      } else {
        loadRecommendations();
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  document.addEventListener('change', (event) => {
    const target = event.target;

    if (target.matches('[data-auto-submit]') && target.form) {
      target.form.submit();
    }

    if (target.matches('[data-variant-selector]')) {
      const selected = target.options ? target.options[target.selectedIndex] : target;
      const form = target.closest('form');
      const button = form ? form.querySelector('[data-add-to-cart]') : null;

      if (button && selected) {
        button.disabled = selected.dataset.available !== 'true';
        button.textContent = selected.dataset.available === 'true'
          ? button.dataset.availableText
          : button.dataset.soldOutText;
      }
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-menu-close]');
    if (!trigger) return;

    const mobileMenu = trigger.closest('.mobile-menu');
    if (mobileMenu) mobileMenu.removeAttribute('open');

    const details = trigger.closest('details');
    if (details && details !== mobileMenu) details.removeAttribute('open');
  });
})();
